import { Button } from '@energybox/react-ui-library/dist/components';
import React, { useEffect, useState } from 'react';
import { Step, StepType } from '../../types/sentinelWizard';
import styles from './SentinelWizardNavigation.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import AlertNotification from '../../containers/Sentinels/AlertNotification';
import { clearApiError } from '../../actions/sentinels';

type Props = {
  setStep: (stepType: StepType) => void;
  stepsCompleted: { [key: string]: boolean };
  loading?: boolean;
  tipComponent?: any;
  handleSubmit: any;
  handleCancel: any;
  handleFinishLater: () => void;
  currentStep: StepType;
  prevStep: Step;
  nextStep: Step;
  nextAction: any;
  prevAction: any;
};

const SentinelWizardNavigation = ({
  currentStep,
  stepsCompleted,
  tipComponent,
  handleCancel,
  handleFinishLater,
  prevStep,
  nextStep,
  nextAction,
  prevAction,
}: Props) => {
  const apiError = useSelector(
    ({ sentinels }: ApplicationState) => sentinels.apiError
  );
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<'success' | 'error' | null>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (apiError) {
      setAlertMessage(`Error: Failed to create sentinel. Please try again.`);
      setAlertType('error');
      setTimeout(() => {
        setAlertMessage(null);
        setAlertType(null);
        dispatch(clearApiError());
      }, 2500);
    }
  }, [apiError]);

  return (
    <div className={styles.root}>
      {alertMessage && (
        <AlertNotification type={alertType!} message={alertMessage} />
      )}
      <div className={styles.tip}>{tipComponent}</div>
      <div className={styles.controls}>
        {prevStep ? (
          <Button fullWidth onClick={() => prevAction()}>
            Previous
          </Button>
        ) : (
          <span />
        )}

        <Button
          fullWidth
          onClick={() => nextAction()}
          disabled={
            currentStep === 'handling' ? false : !stepsCompleted[currentStep]
          }
        >
          {nextStep ? `Next` : `Finish`}
        </Button>
      </div>

      <div className={styles.finishLaterButtonContainer}>
        <Button onClick={handleCancel} variant='text'>
          Cancel
        </Button>
        <Button onClick={handleFinishLater} variant='text'>
          Finish later
        </Button>
      </div>
    </div>
  );
};

export default SentinelWizardNavigation;
